import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldArrayType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { BaseFormlyFieldProps } from '../form-field/public_api';

interface LocaleTabsProps extends BaseFormlyFieldProps {
    images?: string[];
    titles?: string[];
}

export interface FormlyLocaleTabsFieldConfig extends FormlyFieldConfig<LocaleTabsProps> {
    type: 'kendo-locale-tabs' | Type<FormlyFieldLocaleTabs>;
}

@Component({
    selector: 'formly-field-locale-tabs',
    template: `
        <kendo-tabstrip>
            <kendo-tabstrip-tab *ngFor="let tab of field.fieldGroup; let i = index;" [selected]="i === selected">
                <ng-template kendoTabTitle>
                    <img class="tab-image" [src]="props.images[i]" />
                    <span>{{ props.titles[i] }}</span>
                </ng-template>
                <ng-template kendoTabContent>
                    <formly-field [field]="tab"></formly-field>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldLocaleTabs extends FieldArrayType<FieldTypeConfig<LocaleTabsProps>> {
    selected = 0;
}
